import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { ButtonGroup } from "azure-devops-ui/ButtonGroup";

export default class ButtonExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div className="flex-column">
                <p id="basic-buttons-label">Basic buttons:</p>
                <div aria-labelledby="basic-buttons-label" role="group">
                    <ButtonGroup className="flex-wrap">
                        <Button
                            text="Default button"
                            onClick={() => alert("Default button clicked!")}
                        />
                        <Button
                            text="Primary button"
                            primary={true}
                            onClick={() => alert("Primary button clicked!")}
                        />
                        <Button
                            text="Subtle button"
                            subtle={true}
                            onClick={() => alert("Subtle button clicked!")}
                        />
                        <Button
                            text="Danger button"
                            danger={true}
                            onClick={() => alert("Danger button clicked!")}
                        />
                    </ButtonGroup>
                </div>

                <p id="icon-and-link-buttons-label">Icon and link buttons:</p>
                <div aria-labelledby="icon-and-link-buttons-label" role="group">
                    <ButtonGroup className="flex-wrap">
                        <Button
                            text="Icon button"
                            iconProps={{ iconName: "Add" }}
                            onClick={() => alert("Icon Button clicked!")}
                        />
                        <Button
                            ariaLabel="Add"
                            iconProps={{ iconName: "Add" }}
                            onClick={() => alert("Icon Only Button clicked!")}
                        />
                        <Button text="Link button" href="https://www.microsoft.com" />
                    </ButtonGroup>
                </div>
            </div>
        );
    }
}
